import http from '@/api/http';
export function getCompanyMemberPage(params) {
    return http.get(`/companymember`, { params });
}
// seq: companyMemberSeq
export function getCompanyMemberLoginHistoryPage(params) {
    return http.get(`/companymember/${params.cmSeq}/logins`, { params });
}
export function deactivateLogin(loginseq) {
    return http.put(`/companymember/deactivate/${loginseq}`);
}
export function getCompanyMemberById(seq) {
    return http.get(`/companymember/${seq}`);
}
export function getCompanyMemberLicense(params) {
    return http.get(`/companymember/${params.cmSeq}/licenses`, { params });
}
export class MemberForm {
    cmCoSeq;
    userId = '';
    password;
    role = 5;
    status;
    valid = false;
}
export function saveCompanyMember(companyMember) {
    return http.post(`/companymember`, companyMember);
}
